<template>
  <div class="team__entry" id="team__entry">
    <div class="team__entry--content">
      <h1 class="team__entry--content--title">{{ $t("teamTranslate.teamEntryTitle") }}</h1>
    </div>
    <div class="team__entry--anchor-list">
      <a v-on:click="clickfuncTeamProf1()">{{ $t("teamTranslate.teamEntryAnchorToTeamMember1") }}</a>
      <a v-on:click="clickfuncTeamProf2()">{{ $t("teamTranslate.teamEntryAnchorToTeamMember2") }}</a>
      <a v-on:click="clickfuncTeamProf3()">{{ $t("teamTranslate.teamEntryAnchorToTeamMember3") }}</a>
      <!-- <a v-on:click="clickfuncTeamProf4()">{{ $t("teamTranslate.teamEntryAnchorToTeamMember4") }}</a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'team-entry',
  data() {
    return {
      locale: 'fr'
    }
  },
  methods :{
    clickfuncTeamProf1() {
      this.$SmoothScroll(document.getElementById('team__profile--1'));
    },
    clickfuncTeamProf2() {
      this.$SmoothScroll(document.getElementById('team__profile--2'));
    },
    clickfuncTeamProf3() {
      this.$SmoothScroll(document.getElementById('team__profile--3'));
    },
    // clickfuncTeamProf4() {
    //   this.$SmoothScroll(document.getElementById('team__profile--4'));
    // },
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>
